import { useEffect, useState } from "react";
import API from "../../services/API";
import {TableContainer, Table, TableHead, TableBody, TableRow, TableCell, Paper} from '@mui/material';

export default function Stickers(){

    const [items, setItems] = useState(null)

    useEffect(() => {

        API.get('/teachers/me/stickers')
            .then(r => setItems(r.data))

    }, [])

    return items && items.length > 0 &&
        <TableContainer component={Paper}>
            <Table>
                <TableHead>
                    <TableRow>
                        <TableCell align='left'><b>Lien partagé</b></TableCell>
                        <TableCell align='left'><b>Media</b></TableCell>
                        <TableCell align='center'><b>Clics</b></TableCell>
                        <TableCell align='center'><b>Inscriptions</b></TableCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {items.map(i => 
                        <TableRow key={i.id}>
                            <TableCell>{i.title}</TableCell>
                            <TableCell>{i.media.title}</TableCell>
                            <TableCell align='right'>{i.clicks.toLocaleString()}</TableCell>
                            <TableCell align='right'>{i.enrollments.toLocaleString()}</TableCell>
                        </TableRow>
                    )}
                </TableBody>
            </Table>
        </TableContainer>
}